import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SnackbarSuccessIcon = forwardRef<SVGSVGElement, IconProps>(function SnackbarSuccessIcon(
  { color = '#119970', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="url(#paint0_radial_390_22642)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2379 8.37996C16.6351 8.68448 16.7109 9.253 16.4074 9.65095L11.9035 15.5562C11.7447 15.7644 11.504 15.8938 11.2431 15.9111C10.9822 15.9285 10.7266 15.8321 10.5417 15.6468L7.68308 12.7806C7.32955 12.4262 7.32956 11.8525 7.68308 11.498C8.03793 11.1422 8.61424 11.1422 8.96909 11.498L11.0918 13.6263L14.9637 8.54985C15.2683 8.15047 15.8393 8.07434 16.2379 8.37996Z"
        fill={color || 'currentColor'}
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#1EC985" />
      <defs>
        <radialGradient
          id="paint0_radial_390_22642"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(24 12) rotate(179.974) scale(43.5 223.999)"
        >
          <stop stopColor="#32D989" stopOpacity="0.31" />
          <stop offset="0.516781" stopColor="#156B51" stopOpacity="0.3" />
          <stop offset="1" stopColor="#1B1E24" />
        </radialGradient>
      </defs>
    </svg>
  );
});
